import { render, staticRenderFns } from "./AddBestelling.vue.vue?vue&type=template&id=1c13d26b&scoped=true&"
import script from "./AddBestelling.vue.vue?vue&type=script&lang=js&"
export * from "./AddBestelling.vue.vue?vue&type=script&lang=js&"
import style0 from "./AddBestelling.vue.vue?vue&type=style&index=0&id=1c13d26b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c13d26b",
  null
  
)

export default component.exports